import { useEffect, useState, useRef } from 'react';

export default function useInView(threshold = 0.1) {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const element = ref.current; // Capture once
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setIsVisible(true);
            },
            { threshold },
        );

        observer.observe(element);

        return () => {
            observer.unobserve(element);
        };
    }, [threshold]);

    return [ref, isVisible];
}
